import Model from './Model'

export default class MaterialCategory extends Model
{
    static async all () {
        const { data } = await Http.get(route('api.v1.materials.categories.index'))
        return this.make(data)
    }
}
